/**
 * Checks if digiteka is enabled
 * @param {Array} monetising Array of services related to monetisation.
 * @returns {Boolean}
 */
const isDigitekaEnabled = ({ monetising }) => monetising
  && monetising.some((item) => item.service === 'digiteka' && item.enabled);

/**
 * Checks whether they should inject Digiteka
 * @param {Object} options Object with all the fields required to decide if to inject for required vieport.
 * @param {String} viewport Current viewport (mobile or desktop).
 * @returns {Boolean}
 */
const shouldInjectDigiteka = ({ options, viewport }) => {
  const {
    currentRuleComponentTypeWordCount: currentWordCount,
    currentRuleInjectedComponentCount,
    props: {
      monetising,
      adSettings: {
        beforeDigitekaDesktopAds,
        beforeDigitekaMobileAds,
      },
      amp,
    },
  } = options;

  const beforeDigitekaAd = viewport === 'desktop' ? beforeDigitekaDesktopAds : beforeDigitekaMobileAds;

  // viewport checker is disabled with amp so we can
  // only return one digiteka (not one/viewport)
  if (amp && viewport === 'desktop') return false;

  return isDigitekaEnabled({ monetising })
  && currentRuleInjectedComponentCount === 0
  && currentWordCount >= beforeDigitekaAd;
};

export default {
  isDigitekaEnabled,
  shouldInjectDigiteka,
};
